import React, { useMemo, useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import 'features/dashboard/static/downtime/grid/grid.style.css';
import { getAssetData, getGroupsbyId } from 'redux/datasource/dataSourceSlice';
import { useCommonInits } from 'hooks/useCommonInits';
import {
    getAssetsLiveData,
    getApcmGroup,
    getAllAssets,
    getAllGroups,
} from 'redux/datasource/dataSourceActions';
import { useSelector } from 'react-redux';
import { getUser, getUnitIds } from 'redux/auth/authSlice';
import {
    Typography,
    Box,
    Paper,
    Grid,
    Button,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
} from '@mui/material';
import MotionPhotosAutoIcon from '@mui/icons-material/MotionPhotosAuto';
import {
    getPanelValue,
    getAssets,
    getGroups,
} from 'redux/datasource/dataSourceSlice';
import { useParams } from 'react-router-dom';
import { Autorenew } from '@mui/icons-material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
export const AssetsLiveData = panel => {
    const GroupByID = useSelector(getGroupsbyId);
    const [pageSize, setPageSize] = useState(10);
    const { dispatch, select } = useCommonInits();
    const { id } = useParams();
    const Groups = useSelector(getGroups);
    const Assets = select(getAssets);
    const user = useSelector(getUser);
    const panelData = useSelector(state =>
        getPanelValue(state, panel?.panelId),
    );
    const [filteredAssetData, setFilteredAssetData] = useState(
        panelData?.assetdata,
    );
    const [intervalData, setIntervalData] = useState(null);
    const [changeColor, setColorChange] = useState(true);
    const [commSts, setCommSts] = useState('ALL');
    const content = { panel };
    const [groupName, setGroupName] = useState('ALL');
    const units = useSelector(getUnitIds);
    const unitIds = JSON.parse(units);
    const filteredGroups = Groups?.filter(val => {
        return unitIds.find(a => {
            return val.name === a;
        });
    });

    const handleAssets = () => {
        setFilteredAssetData(
            commSts === 'ALL'
                ? panelData?.assetdata
                : panelData?.assetdata.filter(
                      data => data.COMM_STS === commSts,
                  ),
        );
    };

    const getFilteredData = () => {
        if (commSts === 'ALL') {
            return panelData?.assetdata;
        } else {
            return panelData?.assetdata.filter(
                data => data.COMM_STS === commSts,
            );
        }
    };

    useEffect(() => {
        if (Groups) {
            dispatch(getAllGroups());
        }
    }, []);

    const handleAssetStation = e => {
        // alert(groupName);
        const id = groupName;
        // getAsset();
        if (groupName !== 'ALL') {
            dispatch(getApcmGroup({ id }));
        }
    };

    useEffect(() => {
        assetDatas();
    }, [GroupByID, Assets]);

    const assetDatas = () => {
        if (groupName === 'ALL') {
            getlivveData();
        } else {
            dispatch(
                getAssetsLiveData({
                    params: {
                        asset_list: GroupByID?.assets,
                    },
                    panelId: panel.panelId,
                }),
            );
        }
    };

    const getAsset = () => {
        const params = {
            filter: { EQUIP_TYPE: ['APCM'] },
            unit_id: units,
        };
        dispatch(getAllAssets(params));
    };

    const getData = () => {
        setTimeout(() => {
            getAsset();
            assetDatas();
        }, 1000);
    };
    useEffect(() => {
        return () => {
            if (intervalData) {
                clearInterval(intervalData);
            }
        };
    }, [intervalData]);

    const getlivveData = () => {
        dispatch(
            getAssetsLiveData({
                params: { asset_list: Assets.map(i => i.asset_id) },
                panelId: panel.panelId,
            }),
        );
    };

    const getAutoData = () => {
        const setTime = setInterval(() => {
            assetDatas();
        }, 10000);
        setColorChange(false);
        setIntervalData(setTime);

        return () => {
            clearInterval(intervalData);
        };
    };

    const getAutoStopData = () => {
        setColorChange(true);
        clearInterval(intervalData);
        setIntervalData(null);
    };

    useEffect(() => {
        handleAssetStation();
    }, [groupName]);
    useEffect(() => {
        handleAssets();
    }, [commSts]);

    useEffect(() => {
        getAsset();
    }, []);

    useEffect(() => {
        handleAssetStation();
        getlivveData();
    }, [Assets, groupName]);

    const columns = useMemo(
        () => [
            {
                field: 'COMM_STS',
                headerName: 'COMM STS',
                width: 100,
                sortable: false,
                filterable: false,
                textAlign: 'center',
                renderCell: params => {
                    if (params.row.COMM_STS == 1) {
                        return (
                            <Button
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <RadioButtonCheckedIcon
                                    fontSize="large"
                                    style={{
                                        color: '#32B834  ', //green
                                    }}
                                />
                            </Button>
                        );
                    }
                    if (params.row.COMM_STS == 0) {
                        return (
                            <Button
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                <RadioButtonCheckedIcon
                                    fontSize="large"
                                    style={{
                                        color: '#F45F53 ', //red
                                    }}
                                />
                            </Button>
                        );
                    } else {
                        return (
                            <Button
                                style={{
                                    backgroundColor: 'transparent',
                                    border: '0px',
                                }}
                            >
                                {params.row.COMM_STS}
                            </Button>
                        );
                    }
                },
            },
            {
                field: 'asset_id',
                headerName: 'Station Name',
                width: 225,
                sortable: false,
                filterable: false,
                textAlign: 'left',
            },
            {
                field: 'GAS_RATE_TAG',
                headerName: 'Gas Rate',
                width: 100,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    return (
                        <>
                            {/* <h3> */}
                            {params.value
                                ? parseFloat(params.value).toFixed(2)
                                : null}
                            {/* </h3> */}
                        </>
                    );
                },
            },
            {
                field: 'DISP1',
                headerName: 'D1',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',

                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP1) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}
                                    {/* {params.row.DISP1} */}
                                </h3>
                                {params.row.DISP1 ? (
                                    params.row.DISP1_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP1 ? (
                                    params.row.DISP1_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP1 ? (
                                    params.row.DISP1_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP1 ? (
                                    params.row.DISP1_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP2',
                headerName: 'D2',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP2) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP2 ? (
                                    params.row.DISP2_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP2 ? (
                                    params.row.DISP2_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP2 ? (
                                    params.row.DISP2_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP2 ? (
                                    params.row.DISP2_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP3',
                headerName: 'D3',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP3) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP3 ? (
                                    params.row.DISP3_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP3 ? (
                                    params.row.DISP3_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP3 ? (
                                    params.row.DISP3_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP3 ? (
                                    params.row.DISP3_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP4',
                headerName: 'D4',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP4) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP4 ? (
                                    params.row.DISP4_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP4 ? (
                                    params.row.DISP4_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP4 ? (
                                    params.row.DISP4_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP4 ? (
                                    params.row.DISP4_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP5',
                headerName: 'D5',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP5) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP5 ? (
                                    params.row.DISP5_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP5 ? (
                                    params.row.DISP5_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP5 ? (
                                    params.row.DISP5_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP5 ? (
                                    params.row.DISP5_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP6',
                headerName: 'D6',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP6) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP6 ? (
                                    params.row.DISP6_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP6 ? (
                                    params.row.DISP6_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP6 ? (
                                    params.row.DISP6_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP6 ? (
                                    params.row.DISP6_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP7',
                headerName: 'D7',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP7) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP7 ? (
                                    params.row.DISP7_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP7 ? (
                                    params.row.DISP7_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP7 ? (
                                    params.row.DISP7_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP7 ? (
                                    params.row.DISP7_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP8',
                headerName: 'D8',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP8) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP8 ? (
                                    params.row.DISP8_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP8 ? (
                                    params.row.DISP8_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP8 ? (
                                    params.row.DISP8_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP8 ? (
                                    params.row.DISP8_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP9',
                headerName: 'D9',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP9) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP9 ? (
                                    params.row.DISP9_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP9 ? (
                                    params.row.DISP9_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP9 ? (
                                    params.row.DISP9_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP9 ? (
                                    params.row.DISP9_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
            {
                field: 'DISP10',
                headerName: 'D10',
                width: 120,
                sortable: false,
                filterable: false,
                textAlign: 'left',
                renderCell: params => {
                    if (params.row.GAS_RATE_TAG == params.row.DISP10) {
                        return (
                            <>
                                <h3 style={{ color: '#32B834  ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP10 ? (
                                    params.row.DISP10_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP10 ? (
                                    params.row.DISP10_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    } else {
                        return (
                            <>
                                <h3 style={{ color: '#F45F53 ' }}>
                                    {params.value
                                        ? parseFloat(params.value).toFixed(2)
                                        : null}{' '}
                                </h3>
                                {params.row.DISP10 ? (
                                    params.row.DISP10_STS == 0 ? (
                                        <h3 style={{ color: '#F45F53 ' }}>
                                            (OFF)
                                        </h3>
                                    ) : null
                                ) : null}
                                {params.row.DISP10 ? (
                                    params.row.DISP10_STS == 1 ? (
                                        <h3 style={{ color: '#32B834  ' }}>
                                            (ON)
                                        </h3>
                                    ) : null
                                ) : null}
                            </>
                        );
                    }
                },
            },
        ],
        [],
    );

    return (
        <div>
            <Box sx={{ padding: 1 }}>
                <Paper variant="outlined">
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        sx={{ p: 2 }}
                    >
                        <Grid item>
                            <MotionPhotosAutoIcon fontSize="large" />
                        </Grid>
                        <Grid item sx={{ pl: 1 }}>
                            <Typography variant="h5">
                                Station Live Statistics
                            </Typography>
                        </Grid>
                    </Grid>
                    <div
                        style={{
                            marginLeft: '25px',
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div>
                            <FormControl>
                                <InputLabel id="demo-multiple-name-label">
                                    Status
                                </InputLabel>
                                <Select
                                    size="small"
                                    value={commSts}
                                    onChange={e => setCommSts(e.target.value)}
                                    onBlur={handleAssets}
                                    sx={{ width: 200, margin: '10px' }}
                                >
                                    <MenuItem value={'ALL'}>ALL</MenuItem>
                                    <MenuItem value={0}>OFF</MenuItem>
                                    <MenuItem value={1}>ON</MenuItem>
                                </Select>
                            </FormControl>

                            <FormControl>
                                <InputLabel id="demo-multiple-name-label">
                                    Groups
                                </InputLabel>
                                <Select
                                    size="small"
                                    value={groupName || 'ALL'}
                                    onChange={e => setGroupName(e.target.value)}
                                    // onBlur={handleAssetStation}
                                    sx={{ width: 200, margin: '10px' }}
                                >
                                    <MenuItem value={'ALL'}>ALL</MenuItem>

                                    {!user?.app_type.includes('APCM')
                                        ? filteredGroups.map(item => {
                                              return (
                                                  <MenuItem
                                                      value={item._id}
                                                      key={`interval-${item.name}`}
                                                  >
                                                      {item.name}
                                                  </MenuItem>
                                              );
                                          })
                                        : Groups.map(item => {
                                              return (
                                                  <MenuItem
                                                      value={item._id}
                                                      key={`interval-${item.name}`}
                                                  >
                                                      {item.name}
                                                  </MenuItem>
                                              );
                                          })}
                                </Select>
                            </FormControl>

                            <Button
                                variant="outlined"
                                style={{
                                    margin: '10px',
                                }}
                                onClick={() => getData()}
                            >
                                <Autorenew />
                            </Button>
                            {changeColor === true ? (
                                <Button
                                    variant="outlined"
                                    style={{
                                        margin: '10px',
                                        backgroundColor: '#32B834 ',
                                    }}
                                    onClick={() => getAutoData()}
                                >
                                    Start
                                </Button>
                            ) : (
                                <Button
                                    variant="outlined"
                                    style={{
                                        margin: '10px',
                                        backgroundColor: 'red',
                                    }}
                                    onClick={() => getAutoStopData()}
                                >
                                    Stop
                                </Button>
                            )}
                        </div>
                    </div>
                </Paper>

                <Paper sx={{ marginTop: '10px' }}>
                    <Box sx={{ height: '87%', width: '100%' }}>
                        <DataGrid
                            disableColumnMenu
                            rows={getFilteredData() || []}
                            // rows={panelData?.assetdata || []}
                            columns={columns}
                            getRowId={row => row.asset_id}
                            rowsPerPageOptions={[10, 25, 50]}
                            autoHeight={true}
                            pageSize={pageSize}
                            onPageSizeChange={newPage => setPageSize(newPage)}
                            getRowSpacing={params => ({
                                top: params.isFirstVisible ? 0 : -2,
                                bottom: params.isLastVisible ? 0 : -2,
                            })}
                        />
                    </Box>
                </Paper>
            </Box>
        </div>
    );
};
